export default "__VITE_ASSET__xbK7eMRCAk_oU2ev6YOMdw__"